import { useEffect, useRef, useMemo, useState } from "react";
import { useLocation } from 'react-router-dom'
// import PageTitleComponent from "../../SharedComponents/PageTitleComponent";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { insurerListController,insurersList,obj2url } from "../Helper/provider";

import EnforcedIllustrationSub from "./EnforcedIllustrationSub";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import AxiosInstance from "../../AxiosInstance";

const schema = Yup.object().shape({
  policyNumber: Yup.string().required("Policy Number is required"),
  insurerId: Yup.number()
    .min(1, "Insurer is required")
    .typeError("Insurer must be a number")
    .required("Insurer is required"),

  currentFundValue: Yup.number()
    .min(1, "Current Fund Value is required")
    .typeError("Current Fund Value must be a number")
    .required("Current Fund Value is required"),

  returnCalculation: Yup.number()
    .min(1, "Return Calculation is required")
    .typeError("Return Calculation must be a number")
    .required("Return Calculation is required"),
  isReturnMortalityChargeEligible: Yup.string()
    .typeError("Value must be a string")
    .required("Value is required"),
  agreeToPayTerm: Yup.number().nullable().optional(),
});

export default function EnforcedIllustration() {
  const [isLoading, setLoading] = useState(true);
  const [insurerData, setInsurerData] = useState([]);
  const [data, setData] = useState(null);
  const [variantValue, setVariantValue] = useState(null);
  const [
    isReturnMortalityChargeEligibleOptions,
    setisReturnMortalityChargeEligibleOptions,
  ] = useState(null);
  const location = useLocation();
  
  const queryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      policyNumber: params.get("policyno") ?? "",
      insurerId: params.get("insurerid") ?? "",
      currentFundValue: params.get("currentFundValue") ?? "",
      returnCalculation: params.get("returnpercentage") ?? "",
      variant: params.get("variant") ?? "",
      annualPremiumPaid: params.get("annualPremiumPaid") ?? "",
    };
  }, [location.search]);

  const {
    policyNumber,
    insurerId,
    currentFundValue,
    returnCalculation,
    variant,
    annualPremiumPaid
  } = queryParams;


  const componentRef = useRef();

  const handleExportPDF = async () => {
    const input = componentRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/jpeg");

    const pdfWidth = 210; // mm (A4 width)
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    let pdfHeight = (canvasHeight * pdfWidth) / canvasWidth;

    // Increase the height if you want extra length for more content
    pdfHeight = pdfHeight * 1; // or use another multiplier

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [pdfWidth, pdfHeight],
      compress: true,
    });

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${formik.values.policyNumber}.pdf`);
  };

  const formik = useFormik({
    initialValues: {
      policyNumber: policyNumber || "",
      currentFundValue: currentFundValue || 0,
      returnCalculation: returnCalculation || 0,
      insurerId: insurerId || "",
      isReturnMortalityChargeEligible: true,
      agreeToPayTerm: null,
      fetchFromAPI: false,
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      values.isReturnMortalityChargeEligible =
        variantValue === "Legacy" ? "false" : "true";
      let bhartiId = insurerData.find(
        (insurer) => insurer.name === insurersList.AXA
      ).insurerId;

      if (parseInt(values.insurerId) === bhartiId) values.fetchFromAPI = true;
      
      const policyPullResponse = await AxiosInstance().get(
        `/policy/insurer/details?policyNumber=${values.policyNumber}&insurerId=${values.insurerId}`
      );
      console.log(policyPullResponse,'policyPullResponse');
      
      await AxiosInstance()
        .get(`/admin/policy/enforced?` + obj2url(values))
        .then((result) => {
          const data = result.data;
          if (data.policy.product.productType === "ULIP") {
            const modifiedData = removeDecimalsForSpecificKeys(
              data?.graphData,
              keysToRemoveDecimals
            );
            data.graphData = modifiedData;
          }
          setData({ ...data, policyPullData: policyPullResponse.data});

        })
        .catch((error) => {
          setLoading(false);
          toast(error.response.data.message, { type: "error" });
        });
      //   formik.resetForm();
      // setCreatePortfolioModal(false);
      // Handle form submission
    },
  });
  function removeDecimalsForSpecificKeys(data, keys) {
    // Iterate through each object in the array
    return data.map((obj) => {
      // Iterate through each key in the object
      Object.keys(obj).forEach((key) => {
        // Check if the key is one of the specified keys and the value is a number
        if (keys.includes(key) && typeof obj[key] === "number") {
          // Remove decimals using Math.floor
          obj[key] = Math.floor(obj[key]);
        }
      });
      return obj;
    });
  }
  const getInsurer = async () => {
    const result = await insurerListController();
    setInsurerData(result);
  };
  useEffect(() => {
    getInsurer();
  }, []);

  useEffect(() => {
    formik.setFieldValue('insurerId',insurerId)
  }, [insurerData]);

  const checkVariantEnablement = (id) => {
    let maxid = insurerData.find(
      (insurer) => insurer.name === insurersList.MAX
    ).insurerId;

    let bhartiId = insurerData.find(
      (insurer) => insurer.name === insurersList.AXA
    ).insurerId;

    if (parseInt(id) === maxid) {
      setisReturnMortalityChargeEligibleOptions([
        { label: "Income", value: "Income" },
        { label: "Lumsum", value: "Lumsum" },
      ]);
    } else if (parseInt(id) === bhartiId) {
      setisReturnMortalityChargeEligibleOptions([
        { label: "Legacy", value: "Legacy" },
        { label: "Growth", value: "Growth" },
      ]);
    } else {
      setisReturnMortalityChargeEligibleOptions(null);
    }
    formik.setFieldValue("isReturnMortalityChargeEligible", "true");
  };
  const keysToRemoveDecimals = ["endYearFundValueFixed", "endYearFundValue"];
  const onInputChange = async (e) => {
    const { name, value } = e.target;
    if (name === "returnCalculation") setData(null);

    if (name === "insurerId") {
      checkVariantEnablement(value);
    }

    // Update the formik state
    formik.handleChange(e);

    // Validate the input using Yup
    try {
      await schema.validateAt(name, { [name]: value });
      // Clear validation error for the current field
      formik.setFieldError(name, "");
    } catch (error) {
      // Set validation error for the current field
      formik.setFieldError(name, error.message);
    }
  };
  return (
    <div className="">
      <div className="p-1 p-md-4">
        <ToastContainer />
        <div className="tre_flex-vcenter ">
          {/* <PageTitleComponent pageTitle="Enforced Illustration" /> */}
        </div>{" "}
        <div className="">
          {" "}
          <EnforcedIllustrationSub
            ref={componentRef}
            data={data}
            formik={formik}
            insurerData={insurerData}
            onInputChange={onInputChange}
            isReturnMortalityChargeEligibleOptions={
              isReturnMortalityChargeEligibleOptions
            }
            variantValue={variantValue}
            setVariantValue={setVariantValue}
          />
        <span>{insurerData && JSON.stringify(insurerData?.[0]?.name)}</span>

          <div className="flex d-flex justify-content-center">
            {data && (
              <Button className="m-0" onClick={handleExportPDF}>
                Print this page
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
